import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { validateFormData } from "../../../utils/validation";
import { errorMsg, successMsg } from "../../../utils/customFn";
import useApiRequest from "../../../hook/useApiRequest";
import Joi from "joi";
import { API_ENDPOINTS } from "../../../constants/endPoints";

const useOrderDetailsUtils = () => {

  
  const { id } = useParams();
  const navigate = useNavigate();
  const { loading, fetchData } = useApiRequest();
  const languageId = localStorage.getItem("language_id") || "1";

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
  
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0'); // Month is 0-indexed
    const day = `${date.getDate()}`.padStart(2, '0');
    const hours = `${date.getHours()}`.padStart(2, '0');
    const minutes = `${date.getMinutes()}`.padStart(2, '0');
  
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };
  

  const [formData, setFormData] = useState({
    id: "SHIP123456",
    status: "Pickup",
    origin: "Malwa mill indore",
    destination: "Vijay nager indore",
    sender: "John Smith",
    driver: "Sarah Johnson",
    weight: "15.5 kg",
    serviceType: "Express Delivery",
    estimatedDelivery: "2023-08-25",
    actualDelivery: "",
    tracking: [],
   
  });

  const fetchOrderData = async () => {
    const response = await fetchData(
      `${API_ENDPOINTS?.get_orders}/${id}`,
      navigate
    );

    if (response) {

      const pickupAddress = response?.pickup_location || "";     
      const deliveryAddress = response?.dropoff_location  || "";  

      console.log("pickupAddress",pickupAddress)
      console.log("deliveryAddress",deliveryAddress)
  
      const trackingLogs = response?.getOrderLogs?.map(log => {
        let location = log.location || "";
        let status = log.status || "";
  
        if (log.status?.toLowerCase() == "picked_up") {
          location = pickupAddress;
          status = "Picked Up"
        } else if (log.status?.toLowerCase() == "delivered") {
          location = deliveryAddress;
           status = "Delivered"
        }
  
        return {
          date: log.createdAt,
          location,
          status: status || "",
        };
      }) || [];
     

      setFormData((prev) => ({
        ...prev,
        ...response,
        tracking: trackingLogs,
        languageId: languageId,
      }));
    }
  };

  useEffect(() => {
    fetchOrderData();
  }, [id]);

 

  return {
    formData,
    loading,
    fetchData,
    formatDateTime,
    navigate
  };
};

export default useOrderDetailsUtils;
